import Da from './da';
import De from './de';
import En from './en';
import Es from './es';
import Fi from './fi';
import Fr from './fr';
import It from './it';
import Jp from './jp';
import Nb from './nb';
import Sv from './sv';

interface PreviousTermsAndConditionsProps {
  readonly locale: string;
}

const PreviousTermsAndConditions = ({
  locale,
}: PreviousTermsAndConditionsProps) => {
  switch (locale) {
    case 'de':
      return <De />;
    case 'es':
      return <Es />;
    case 'fi':
      return <Fi />;
    case 'it':
      return <It />;
    case 'fr':
      return <Fr />;
    case 'ja':
      return <Jp />;
    case 'da':
      return <Da />;
    case 'nb':
      return <Nb />;
    case 'sv':
      return <Sv />;
    default:
      return <En />;
  }
};

export default PreviousTermsAndConditions;
